import { createSlice } from "@reduxjs/toolkit";

export const createDemoSlice = createSlice({
  name: "createDemo",
  initialState: {
    data: null,
    error: null,
    isLoading: false
  },
  reducers: {
    startCreateDemo: (state) => { state.isLoading = true; },
    setCreateDemo: (state, { payload: { data = null, error = null }}) => {
      state.data = data;
      state.error = error;
      state.isLoading = false;
    }
  }
});

export const { startCreateDemo, setCreateDemo } = createDemoSlice.actions;
